package org.vreo.devicehub.features.core.presentation.fileSaver

import kotlinx.browser.document
import kotlinx.coroutines.await
import org.khronos.webgl.Uint8Array
import org.w3c.dom.HTMLAnchorElement
import org.w3c.dom.url.URL
import org.w3c.files.Blob
import org.w3c.files.BlobPropertyBag

actual object FileSaver {
    actual suspend fun save(
        fileName: String,
        bytes: ByteArray,
        mimeType: String
    ) {
        // Convert ByteArray → Uint8Array
        val uint8Array = Uint8Array(bytes.toTypedArray())

        // Create Blob
        val blob = Blob(
            arrayOf(uint8Array),
            BlobPropertyBag(type = mimeType)
        )

        // Create URL
        val url = URL.createObjectURL(blob)

        // Create temporary <a> element
        val anchor = document.createElement("a") as HTMLAnchorElement
        anchor.href = url
        anchor.download = fileName

        // Trigger download
        document.body?.appendChild(anchor)
        anchor.click()
        document.body?.removeChild(anchor)

        // Cleanup
        URL.revokeObjectURL(url)
    }
}